/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetMarketTrandRequest, TGetMarketTrandModel, IMappers, TGetMarketTrandResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetMarketTrandResponse } from '../../entities/market_trand/GetMarketTrandResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetMarketTrandModel(parameters: IGetMarketTrandRequest): TGetMarketTrandModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v1/get-market-trand/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetMarketTrandOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMarketTrandRequest;
}

export async function fetchGetMarketTrand<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMarketTrandOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetMarketTrandResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetMarketTrandModel(parameters),
    config,
  )) as FetchResponse<TGetMarketTrandResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMarketTrandResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetMarketTrandResponse>;
}
